var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinopsisLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:url(#c);}.e{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -1361.02,
    y1: -1803.55,
    x2: -731.32,
    y2: -1803.55,
    gradientTransform: "translate(-63.25 2487.36) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8300be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f556e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 407.51,
    y1: 696.64,
    x2: 1080,
    y2: 696.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0063ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#0078d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#00a1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#00c3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00ddf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00f0f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#00fbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M588.37,766.72c49.06,0,88.45-42.23,83.73-92.24-4.11-43.58-42.44-76-86.21-76.01h-94.24c-55.44,0-105.71-22.56-142.12-58.97-36.41-36.41-58.96-86.67-58.97-142.11,0-110.88,90.21-201.08,201.08-201.08h48.36c87.45,0,131.24-105.73,69.41-167.57h0c-38.33-38.33-100.48-38.33-138.82,0L28.75,470.59c-38.33,38.33-38.33,100.48,0,138.82l128.57,128.57c18.41,18.41,43.38,28.75,69.41,28.75h361.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M922.68,342.02c-18.41-18.41-43.38-28.75-69.41-28.75H491.64c-46.38,0-84.12,37.74-84.13,84.13,.01,46.38,37.75,84.12,84.13,84.12h92.45c109.41,0,202.01,85.63,205.26,194.99,3.37,113.64-88.09,207.17-200.99,207.17h-48.36c-87.45,0-131.24,105.73-69.41,167.57h0c38.33,38.33,100.48,38.33,138.82,0l441.84-441.84c38.33-38.33,38.33-100.48,0-138.82l-128.57-128.57Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinopsisLogo);
export default __webpack_public_path__ + "static/media/sinopsis_logo.2ce22aec76004ab74a5434f525e32372.svg";
export { ForwardRef as ReactComponent };